/** InsCoder WANG.J 2026-07-21 B + Community short offer banner lifecycle support. **/
if (!customElements.get('community-short-offer')) customElements.define('community-short-offer', class extends HTMLElement {});
/** InsCoder WANG.J 2026-07-21 E + Community short offer banner lifecycle support. **/
